import type { IExternalComponentWixCodeUrlGenerator, ExternalComponentSiteConfig } from '../types'

import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from '../symbols'

const getClientConfig = ({ forceBundlerDevMode }: { forceBundlerDevMode: boolean }) =>
	forceBundlerDevMode || process.env.NODE_ENV === 'development' ? 'REMOTE_UI_DEV' : 'REMOTE_UI'
const getSsrConfig = ({ forceBundlerDevMode }: { forceBundlerDevMode: boolean }) =>
	forceBundlerDevMode || process.env.NODE_ENV === 'development' ? 'REMOTE_UI_SSR_DEV' : 'REMOTE_UI_SSR'

const fixVeloFileUrl = (url: string) => {
	const matchResult = url.match(/^(\/)?components/)
	return matchResult ? `components/${encodeURIComponent(url.replace(`${matchResult[0]}/`, ''))}` : url
}

export const ExternalComponentWixCodeUrlGenerator = withDependencies<IExternalComponentWixCodeUrlGenerator>(
	[named(SiteFeatureConfigSymbol, name)],
	(externalComponentSiteConfig: ExternalComponentSiteConfig) => {
		return {
			generateUrl: ({ componentRelativeUrl, fileType = 'js', appDefId = '', cacheKillerCounter }) => {
				const { wixCodeBundlersUrlData, forceBundlerDevMode, dependenciesToken } = externalComponentSiteConfig
				const { url, queryParams } =
					wixCodeBundlersUrlData.appDefIdToWixCodeBundlerUrlData[appDefId] ?? wixCodeBundlersUrlData

				const veloFileUrl = fixVeloFileUrl(componentRelativeUrl)
				const head = url + veloFileUrl.replace('public/', '')
				const configType = process.env.browser
					? getClientConfig({ forceBundlerDevMode })
					: getSsrConfig({ forceBundlerDevMode })
				const queryParamsForCssFiles =
					fileType === 'css' ? ['bundle-file-type=css', 'css-prefix-selector=.byoc-root'] : []
				const tail = [
					'no-umd=false',
					queryParams,
					typeof cacheKillerCounter === 'undefined' ? '' : `cacheKiller=${cacheKillerCounter}`,
					`byoc-config=${configType}`,
					`dependencies-token=${dependenciesToken}`,
					'add-ui-lib-externals=true',
					// 'use-esbuild-loader=true',
					...queryParamsForCssFiles,
				]
					.filter((v) => v !== '')
					.join('&')
				return `${head}?${tail}`
			},
		}
	}
)
